// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"style_InputLabel__3kSwa","mark":"style_mark__3tmcm","height":"style_height___nzNj"};